export const clientId = '2'
export const clientSecret = 'QSwW3a2sBdoJYOBnFo66gPAFHEHgcGGpzA1Fqsdv'
export const companyName = 'Callistech'
